import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        borderTop: '1px solid #e5e7eb',
        py: 2,
        mt: 4,
        backgroundColor: '#ffffff',
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          px: 2,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'center', md: 'center' },
          justifyContent: { xs: 'center', md: 'space-between' },
          gap: { xs: 1, md: 2 },
          textAlign: { xs: 'center', md: 'left' },
          fontSize: 14,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins, var(--text-font)',
          }}
        >
          © {year} D3 Producciones. Todos los derechos reservados.
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Poppins, var(--text-font)',
            cursor: 'pointer',
            textDecoration: 'underline',
            textDecorationThickness: '1px',
            textUnderlineOffset: '3px',
          }}
        >
          Aviso de privacidad
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
